var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1671069597847,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 36846,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M939.9 373.2L764.4 154.7c-17.5-22.3-46.3-36.7-75-36.7H335.3c-28.7 0-55.8 12.8-75 36.7L84.9 373.2c-30.3 36.7-27.1 90.9 4.8 126l355.7 376.5 4.8 4.8c17.5 16 41.5 25.5 65.4 25.5h3.2c25.5-1.6 49.4-11.2 67-30.3l347.7-374.9c33.5-36.7 35.1-90.9 6.4-127.6z m-52.6 83L539.5 831c-6.4 6.4-14.4 9.6-22.3 9.6-8 0-16-3.2-22.3-8l-357.3-378c-11.2-11.2-11.2-28.7-1.6-41.5l173.9-218.5c6.4-8 16-12.8 25.5-12.8h354.1c9.6 0 19.1 4.8 25.5 12.8l175.5 218.5c7.9 12.8 7.9 30.3-3.2 43.1z",
    fill: "",
    "p-id": 36847
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M680.3 417.8L514.4 594.9 343.7 414.7c-12.8-12.8-31.9-14.4-46.3-1.6-12.8 11.2-12.8 31.9-1.6 44.7l172.3 181.8 3.2 3.2c25.5 23.9 65.4 22.3 90.9-3.2l165.9-180.3c11.2-12.8 11.2-33.5-1.6-44.7-14.3-11.1-33.5-9.5-46.2 3.2z",
    fill: "",
    "p-id": 36848
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipMenu);
export default __webpack_public_path__ + "static/media/VIPMenu.d51bdd69.svg";
export { ForwardRef as ReactComponent };